// §4.4 partial — preferences route. Composer auto-collects into routes.generated.ts.
// P0-48 R76: /preferences is v2-only (not present in DEV/legacy). DEV exposes these
// controls via the Configuracoes modal + RobotStrategyModal. Kept as internal
// admin convenience route; intentional divergence documented in parity-evidence/p1c-visual-audit.md.
import { lazyWithRetry } from "@/lib/lazy/lazyWithRetry";
import type { RouteObject } from "react-router-dom";

const PreferencesPage = lazyWithRetry(() => import("./pages/PreferencesPage"));

const routes: RouteObject[] = [
  { path: "/preferences", Component: PreferencesPage },
];

export default routes;
